module.exports = __webpack_public_path__ + "img/headportrait_9_icon.1849ccf4.png";